module.exports = __webpack_public_path__ + "img/icon-37.13f8dc74.svg";